"use client";

import React from "react";
import { ArrowDownRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const ministryCategories = [{
  label: "ADULTOS Y FAMILIAS",
  href: "#adultos-familias"
}, {
  label: "JÓVENES",
  href: "#jovenes"
}, {
  label: "NIÑOS",
  href: "#ninos"
}, {
  label: "LÍDERES Y MINISTROS",
  href: "#lideres-ministros"
}, {
  label: "EDUCACIÓN",
  href: "#educacion"
}];
export default function Ministries() {
  const prefersReducedMotion = useReducedMotion();
  return <section id="ministerioshero" data-nav="dark" className="relative min-h-[85vh] md:min-h-screen w-full bg-background text-foreground flex flex-col justify-between overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 bg-black">
        <img src="https://current-thrush.10web.cloud/wp-content/uploads/2026/08/Header_Ministries.jpg" data-wvc-srcset="https://current-thrush.10web.cloud/wp-content/uploads/2026/08/Header_Ministries.jpg" data-wvc-sizes="100vw" alt="Concierto y adoración en el escenario" loading="eager" decoding="async" className="h-full w-full object-cover object-center opacity-85" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-black/60" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-transparent to-black/50" />
      </div>

      {}
      <div className="relative z-10 flex-1 flex flex-col justify-end px-6 sm:px-12 lg:px-20 pb-16 pt-32">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 max-w-7xl w-full mx-auto">
          {}
          <motion.div initial={prefersReducedMotion ? false : {
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: "easeOut"
        }} className="max-w-2xl">
            <h1 className="text-4xl tracking-tight text-white uppercase font-sans drop-shadow-md !font-normal sm:text-6xl md:text-7xl lg:text-8xl">
              MINISTERIOS
            </h1>
          </motion.div>

          {}
          <motion.div initial={prefersReducedMotion ? false : {
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: "easeOut"
        }} className="self-start md:self-end">
            <Button asChild size="icon" className="size-14 sm:size-16 rounded-full bg-white text-black hover:bg-white/90 shadow-2xl transition-transform duration-300 hover:scale-105" aria-label="Explorar ministerios">
              <Link to="#categorias">
                <ArrowDownRight className="size-6 sm:size-7 text-black stroke-[2.5]" />
              </Link>
            </Button>
          </motion.div>
        </div>
      </div>

      {}
      <div className="relative z-10 w-full px-4 sm:px-8 pb-4 pt-2">
        <div className="max-w-6xl mx-auto">
          <nav aria-label="Categorías de Ministerios" className="bg-black/95 backdrop-blur-md rounded-full py-3 sm:py-4 px-4 sm:px-8 border border-white/10 shadow-2xl">
            <ul className="flex flex-wrap items-center justify-center gap-y-2 text-xs sm:text-sm font-semibold tracking-wider text-white">
              {ministryCategories.map((cat, i) => <li key={cat.label} data-index={i} className="flex items-center">
                  <Link to={cat.href} className="px-3 sm:px-5 py-1 text-white/90 hover:text-white transition-colors uppercase whitespace-nowrap">
                    {cat.label}
                  </Link>
                  {i < ministryCategories.length - 1 && <span aria-hidden="true" className="hidden sm:inline-block w-px h-3.5 bg-white/30 mx-1" />}
                </li>)}
            </ul>
          </nav>
        </div>
      </div>
    </section>;
}